import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { EvergladesToken } from './api-models';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AuthorisationTokenService {
  private apiName = 'servlet/auth/token/';
  private apiService: ApiService;

  constructor(private httpClient: HttpClient) {
    this.apiService = new ApiService(this.httpClient);
    this.apiService.rawApiURL = this.apiService.apiURL;
    this.apiService.apiVersion = '';
  }

  public generateJWTAccessToken(): Observable<EvergladesToken> {
    return this.apiService.post(this.apiName, 'session');
  }
}
